import type {
  ApiEmailSendersResponse,
  PrayEmailSendersResponse,
  ApiEmailSender,
  PrayEmailSender,
  ApiEmailSenderDomain,
  PrayEmailSenderDomain,
} from '../types';

export function mapEmailSender(sender: ApiEmailSender): PrayEmailSender {
  return {
    id: sender.id,
    artistId: sender.artist_id,
    name: sender.name,
    emailUsername: sender.email_username,
    domain: sender.domain,
    username: sender.username,
    isDefault: sender.is_default,
    isPrayDomainSender: sender.is_pray_domain_sender,
    isDynamic: sender.is_dynamic,
    replyToEmail: sender.reply_to_email,
    createdAt: sender.created_at,
    updatedAt: sender.updated_at,
  };
}

export function mapEmailSenderDomain(domain: ApiEmailSenderDomain): PrayEmailSenderDomain {
  return {
    id: domain.id,
    domainName: domain.domain_name,
    status: domain.status,
    isPrimary: domain.is_primary,
    isPrayDomain: domain.is_pray_domain,
    dnsRecords: domain.dns_records,
    createdAt: domain.created_at,
    updatedAt: domain.updated_at,
  };
}

export function mapEmailSendersResponse(response: ApiEmailSendersResponse): PrayEmailSendersResponse {
  return {
    senders: response.senders.map(mapEmailSender),
    domains: response.domains.map(mapEmailSenderDomain),
  };
}
